import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Login from "../routes/login/Login";
import Button from "./Button";
import YellowConfirm from "./YellowConfirm";
import HomeButton from "./HomeButton";
import Home from "../routes/home/Home";
import ApartmentButton from "./ApartmentButton";
import Apartment from "../routes/apartment/Apartment";
import AccountManagement from "../routes/accountManagement/AccountManagement";
import Table from "./Table";
import TableBottom from "./TableBottom";
import Chat from "./Chat";
import { connect } from "react-redux";
import { getAllApartments } from "../reducers/apartments";
import Bilancio from "./Bilancio";

class Router extends React.Component {
  render() {
    return (
      <BrowserRouter>
        {() => this.setState({ locationSwitch: window.location })}
        <Switch>
          <Route exact path="/" render={(props) => <Login {...props} />} />
          <Route exact path="/Home" render={(props) => <Home {...props} />} />
          <Route
            exact
            path="/Profile"
            render={(props) => <Home {...props} />}
          />
          <Route
            exact
            path="/AccountManagement"
            render={(props) => <AccountManagement {...props} />}
          />
          <Route
            exact
            path="/:id"
            render={(props, match) => (
              <Apartment {...props} apartmentData={this.props.apartments} />
            )}
          />
          <Route exact path="/Prova" render={(props) => <Chat {...props} />} />
          <Route
            exact
            path="/Prova2"
            render={(props) => (
              <Bilancio {...props} text={"Conferma"} buttonText={"Prova button"} />
            )}
          />
        </Switch>
      </BrowserRouter>
    );
  }
}

const mapStateToProps = (state) => ({
  apartments: state.apartments.data,
  loading: state.apartments.loading,
  error: state.apartments.error,
});

export default connect(mapStateToProps, { getAllApartments })(Router);
